import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const REFRESH_STATEMENT = gql`
    mutation RefreshStatement($refreshStatementRequest: RefreshStatementRequestDto!) {
        refreshStatement(refreshStatementRequest: $refreshStatementRequest) {
            year
        }
    }
`;

const useRefreshStatement = () => {
    const [mutate, { loading, error }] = useMutation(REFRESH_STATEMENT);

    const refreshStatement = async (consultantUuid, year, month) => {
        return mutate({
            variables: {
                refreshStatementRequest: {
                    consultantUuid,
                    year,
                    month,
                },
            },
        });
    };

    return {
        refreshStatement,
        loading,
        error,
    };
};

export default useRefreshStatement;
